export const checkUserRole = (userRole, app_role, permissions, activityId) => {
  if (userRole === 0) return true
  if (app_role === 1) {
    return userRole === 1 && permissions.filter((p) => p.type === "activity" && p.resource === activityId).length > 0
  }
  return app_role >= userRole
}
